import { render, staticRenderFns } from "./_Detail.vue?vue&type=template&id=721a11f5&scoped=true"
import script from "./_Detail.vue?vue&type=script&lang=ts"
export * from "./_Detail.vue?vue&type=script&lang=ts"
import style0 from "./_Detail.vue?vue&type=style&index=0&id=721a11f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721a11f5",
  null
  
)

export default component.exports